/**
 * The card the two manage-page panels sit in: title, an optional meta reading
 * beside it, one action on the right, and the body.
 *
 * Eager, and shared with the skeleton for the reason `log-source-table-frame`
 * gives — the titles and both buttons are drawable without a server response
 * (P-05 §1), and one owner is what stops the loading and resolved panels
 * drifting apart. Only the body differs between them.
 */
import { Card } from '@/components/ui/card'

import type { ReactNode } from 'react'

type LogSourcePanelFrameProps = {
	title: string
	/** A reading that qualifies the title — `Last run 2:41 PM`. */
	meta?: ReactNode
	/** The panel's one button. Real-and-disabled while there is nothing to run. */
	action: ReactNode
	children: ReactNode
}

export const LogSourcePanelFrame = ({
	title,
	meta,
	action,
	children,
}: LogSourcePanelFrameProps) => {
	return (
		<Card className="gap-0 p-0">
			<div className="flex items-center justify-between gap-3 px-4 py-3">
				<div className="flex min-w-0 items-baseline gap-2">
					<h3 className="font-medium">{title}</h3>
					{meta ? (
						<span className="text-muted-foreground truncate text-xs">
							{meta}
						</span>
					) : null}
				</div>

				{action}
			</div>

			<div className="flex flex-1 flex-col gap-3 px-4 pt-1 pb-4">
				{children}
			</div>
		</Card>
	)
}
